// removed by extract-text-webpack-plugin
module.exports = {"container":"container_SearchInput","input":"input_SearchInput","search-btn":"search-btn_SearchInput","searchBtn":"search-btn_SearchInput","icon":"icon_SearchInput"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchInput/SearchInput.scss
// module id = 237
// module chunks = 0